import { useState } from "react";
import { Outlet } from "react-router-dom";
import MANavbar from "./MANavbar";
import MASidebar from "./MASidebar";

const MALayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };
  return (
    <div className="dashboard-layout">
      <MANavbar toggleSidebar={toggleSidebar} />
      <div className="layout-wrapper">
        <div
          className={`sidebar-container ${isSidebarOpen ? "open" : "closed"}`}
        >
          <MASidebar />
        </div>

        <div
          className={`content-container ${isSidebarOpen ? "shrink" : "expand"}`}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};
export default MALayout;
